import React, { useState } from 'react';

const OfferImageGallery = ({ images }) => {
    const [mainImage, setMainImage] = useState(images?.[0]);

    const handleThumbnailClick = (clickedImage) => {
        if (clickedImage === mainImage) return;
        setMainImage(clickedImage);
    };

    const thumbnailImages = images?.filter(img => img !== mainImage) || [];

    return (
        <div>
            {mainImage?.large_part_offer_image_url && (
                <img
                    src={mainImage.large_part_offer_image_url}
                    alt="Glavna slika ponude"
                    style={styles.mainImage}
                />
            )}

            <div style={styles.thumbnailContainer}>
                {thumbnailImages.map((img, index) => (
                    <img
                        key={index}
                        src={img.small_part_offer_image_url}
                        alt={`Thumbnail ${index + 1}`}
                        style={styles.thumbnail}
                        onClick={() => handleThumbnailClick(img)}
                    />
                ))}
            </div>
        </div>
    );
};

export default OfferImageGallery;

const styles = {
    mainImage: {
        width: '400px',
        height: 'auto',
        marginBottom: '10px',
        borderRadius: '8px',
    },
    thumbnailContainer: {
        display: 'flex',
        gap: '10px',
    },
    thumbnail: {
        width: '80px',
        height: 'auto',
        cursor: 'pointer',
        borderRadius: '6px',
    },
};
